"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _core = require("@popperjs/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DropdownNavbar = function DropdownNavbar(_ref) {
  var text = _ref.text,
      items = _ref.items,
      navColor = _ref.navColor;

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dropdownPopoverShow = _React$useState2[0],
      setDropdownPopoverShow = _React$useState2[1];

  var _React$useState3 = _react.default.useState(""),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      menuClasses = _React$useState4[0],
      setMenuClasses = _React$useState4[1];

  var _React$useState5 = _react.default.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      animating = _React$useState6[0],
      setAntimating = _React$useState6[1];

  var _React$useState7 = _react.default.useState("origin-top-right"),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      transformOrigin = _React$useState8[0],
      setTransformOrigin = _React$useState8[1];

  var btnDropdownRef = /*#__PURE__*/_react.default.createRef();

  var popoverDropdownRef = /*#__PURE__*/_react.default.createRef();

  var origins = {
    "top-start": "origin-bottom-left",
    "top-end": "origin-bottom-right",
    "bottom-start": "origin-top-left",
    "bottom-end": "origin-top-right",
    "right-start": "origin-top-left",
    "right-end": "origin-top-left",
    "left-start": "origin-top-right",
    "left-end": "origin-top-right",
    bottom: "origin-top",
    top: "origin-bottom",
    left: "origin-right",
    right: "origin-left"
  };

  var startAnimation = function startAnimation() {
    if (!animating) {
      setAntimating(true);

      if (dropdownPopoverShow) {
        setMenuClasses("");
        setTimeout(function () {
          setDropdownPopoverShow(false);
        }, 310);
      } else {
        var popperObject = (0, _core.createPopper)(btnDropdownRef.current, popoverDropdownRef.current, {
          placement: "bottom-start"
        });
        setTransformOrigin(origins[popperObject.state.placement]);
        setDropdownPopoverShow(true);
        setTimeout(function () {
          setMenuClasses("opacity-100 scale-100 ");
        }, 10);
      }

      setTimeout(function () {
        setAntimating(false);
      }, 350);
    }
  };

  var linkColor = {
    light: "text-blueGray-800",
    white: "text-blueGray-800",
    transparent: "lg:text-white text-blueGray-800",
    dark: "text-white",
    black: "text-white",
    blueGray: "text-white",
    red: "text-white",
    orange: "text-white",
    amber: "text-white",
    emerald: "text-white",
    teal: "text-white",
    lightBlue: "text-white",
    indigo: "text-white",
    purple: "text-white",
    pink: "text-white"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    className: "hover:opacity-75 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold transition-all duration-150 ease-in-out " + linkColor[navColor],
    href: "#pablo",
    ref: btnDropdownRef,
    onClick: function onClick(e) {
      e.preventDefault();
      startAnimation();
    }
  }, text, " ", /*#__PURE__*/_react.default.createElement("i", {
    className: "ml-1 fas fa-caret-down transition-all duration-200 ease-in-out transform "
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: popoverDropdownRef,
    className: (dropdownPopoverShow ? "block " : "hidden ") + " z-50"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: transformOrigin + " bg-white text-base float-left p-2 border list-none text-left rounded-lg shadow-lg min-w-48 transition-all duration-100 ease-in-out transform scale-95 opacity-0 absolute " + menuClasses
  }, items.map(function (prop, key) {
    if (prop.disabled) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "uppercase font-bold text-xs px-3 pt-4 block w-full whitespace-nowrap bg-transparent text-blueGray-400",
        key: key
      }, prop.children);
    } else {
      if (prop.to) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({}, prop, {
          key: key,
          className: "text-sm px-3 py-2 block w-full whitespace-nowrap bg-transparent hover:bg-blueGray-100 rounded transition-all duration-100"
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("a", _extends({}, prop, {
          key: key,
          className: "text-sm px-3 py-2 block w-full whitespace-nowrap bg-transparent hover:bg-blueGray-100 rounded transition-all duration-100"
        }));
      }
    }
  }))));
};

DropdownNavbar.defaultProps = {
  items: []
};
DropdownNavbar.propTypes = {
  // text of the dropdown
  text: _propTypes.default.string,
  // array of properties to pass to the link object
  // if you pass a prop named to, the link will be
  // generated using Link from react-router-dom
  // NOTE: if you pass disabled as prop inside this object
  // // // the link will be rendered as a span element
  items: _propTypes.default.arrayOf(_propTypes.default.object),
  // you specify the nav color, so that the
  // dropdown text will be styled accordingly
  navColor: _propTypes.default.oneOf(["dark", "light", "transparent", "white", "black", "blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"])
};
var _default = DropdownNavbar;
exports.default = _default;
